export default class Renderer {
  constructor(data, options = {}) {
    this.type = data?.type ?? 'default_renderer';
    this.options_ = options;
  }

  getType() {
    return this.type;
  }

  getLegendElement() {
    console.warn('Renderer.getLegendElement must be implement in sub-class');
  }
}
